import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function OfferStop(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#EB5757" fillOpacity="0.4"/>
      <path d="M22 10H10V22H22V10Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
